import { IProps } from "./types";
import cls from "./table.module.scss";
import React, { useEffect, useState } from "react";

const ContentTable: React.FC<IProps> = ({
                                            item: {
                                                convertedSettings: { styles, parentStyles },
                                                customClassNames,
                                                contentTableSettings: {
                                                    gap,
                                                    fontSize,
                                                    activeStyles,
                                                    hoveredStyles,
                                                    tableItems = [],
                                                    boldTitle = false,
                                                    boldTitleHover = false,
                                                    boldTitleActive = false,
                                                    tablePosition = 'start'
                                                } = {}
                                            }
                                        }) => {
    const [activeTitle, setActiveTitle] = useState<number | null>(null);
    const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

    const alignment = {
        "start": { left: "25px" },
        "end": { right: "25px" },
    };

    const containerStyles = {
        ...styles,
        ...alignment[tablePosition]
    };

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY === 0) {
                if (activeTitle !== null) {
                    setActiveTitle(null);
                }
                return;
            }

            let closestIndex: number | null = null;
            let minDistance = Number.POSITIVE_INFINITY;

            tableItems.forEach(({ rowId }, index) => {
                const element = document.getElementById(rowId);
                if (element) {
                    const rect = element.getBoundingClientRect();
                    const headerOffset = 130;
                    const distanceFromTop = Math.abs(rect.top - headerOffset);
                    if (rect.top <= window.innerHeight / 2 && distanceFromTop < minDistance) {
                        minDistance = distanceFromTop;
                        closestIndex = index;
                    }
                }
            });

            if (closestIndex !== null && closestIndex !== activeTitle) {
                setActiveTitle(closestIndex);
            }
        };

        window.addEventListener("scroll", handleScroll);
        handleScroll();

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [tableItems, activeTitle]);

    return (
        <div className={`${customClassNames} ${cls.main__container}`} style={containerStyles}>
            <div style={{ gap: `${gap}px` }} className={cls.contents__table}>
                {tableItems.map(({ rowId, rowName }, index: number) => {
                    const isActive = activeTitle === index;
                    const isHovered = hoveredIndex === index;

                    const bold = boldTitle ? { fontWeight: "bold" } : {};
                    const boldHover = boldTitleHover ? { fontWeight: "bold" } : {};
                    const boldActive = boldTitleActive ? { fontWeight: "bold" } : {};

                    const itemStyle = {
                        fontSize: `${fontSize}px`, ...bold,
                        ...(isActive ? { ...activeStyles, ...boldActive } : {}),
                        ...(isHovered && !isActive ? { ...hoveredStyles, ...boldHover } : {}),
                    };

                    return (
                        <div key={index} className={cls.content__item}>
                            <a
                                href={`#${rowId}`}
                                style={itemStyle}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setActiveTitle(index);
                                }}
                                onMouseEnter={() => setHoveredIndex(index)}
                                onMouseLeave={() => setHoveredIndex(null)}
                            >
                                {rowName}
                            </a>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default ContentTable;
